import React from 'react';

interface Props {
    dopClass1?: string,
    dopClass2?: string,
    countPage: number,
    currentPage: number,
    onCurrentPage: (page: number) => void
}


export class PaginationCatalog extends React.Component<Props, {}> {

    render() {
        const {countPage, currentPage, onCurrentPage,dopClass1,dopClass2} = this.props;

        const items = [];

        let prev = 1;
        let next = 1;

        if (currentPage > 1) {
            prev=currentPage-1;
        }

        if (currentPage < countPage) {
            next=currentPage+1;
        }


        if (countPage < 2) {
            return null;
        }

        let start = 1;
        let end = 5;

        if (countPage > 6) {
            if (currentPage > 3) {
                start = currentPage - 2;
                end = currentPage + 2;
                if (end > countPage) {
                    end = countPage;
                }
            }
        } else {
            end = countPage;
        }


        for (let i = start; i <= end; i++) {
            if (i !== currentPage) {
                items.push(<li key={'pages-'+i} onClick={() => onCurrentPage(i)} className="pages__item"><span>{i}</span></li>);
            } else {
                items.push(<li key={'pages-'+i} className="pages__item page__active"><span>{i}</span></li>);
            }
        }

        let elPrev = <div className="pages-img">
            <span onClick={() => onCurrentPage(prev)}>
                <svg width="10" height="18" viewBox="0 0 10 18" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9.03033 16.5303C9.2966 16.2641 9.3208 15.8474 9.10295 15.5538L9.03033 15.4697L2.561 9L9.03033 2.53033C9.2966 2.26406 9.3208 1.8474 9.10295 1.55379L9.03033 1.46967C8.76406 1.2034 8.3474 1.1792 8.05379 1.39705L7.96967 1.46967L0.96967 8.46967C0.703403 8.73594 0.679197 9.1526 0.897052 9.44621L0.96967 9.53033L7.96967 16.5303C8.26256 16.8232 8.73744 16.8232 9.03033 16.5303Z"
                        fill="#8290A9" stroke="#8290A9"/>
                </svg>
            </span>
        </div>;

        if (currentPage === 1) {
            elPrev = <></>;
        }

        let elNext = <div className="pages-img">
            <span  onClick={() => onCurrentPage(next)}>
                <svg width="10" height="18" viewBox="0 0 10 18" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.96967 16.5303C0.703403 16.2641 0.679197 15.8474 0.897052 15.5538L0.96967 15.4697L7.439 9L0.96967 2.53033C0.703403 2.26406 0.679197 1.8474 0.897052 1.55379L0.96967 1.46967C1.23594 1.2034 1.6526 1.1792 1.94621 1.39705L2.03033 1.46967L9.03033 8.46967C9.2966 8.73594 9.3208 9.1526 9.10295 9.44621L9.03033 9.53033L2.03033 16.5303C1.73744 16.8232 1.26256 16.8232 0.96967 16.5303Z"
                        fill="#8290A9" stroke="#8290A9"/>
                </svg>
            </span>
        </div>;

        if (countPage === currentPage) {
            elNext = <></>;
        }

        let itemsEnd = <></>;
        if(countPage>7 && currentPage<countPage-2){
            itemsEnd=<>
                <li className="pages__item"><span>...</span></li>
                <li onClick={() => onCurrentPage(countPage)} className="pages__item"><span >{countPage}</span></li>
            </>;
        }


        let itemsStart = <></>;
        if(countPage>6 && currentPage>4){
            itemsStart=<>
                <li onClick={() => onCurrentPage(1)} className="pages__item"><span >{1}</span></li>
                <li className="pages__item"><span>...</span></li>
            </>;
        }else if(countPage>6 && currentPage===4){
            itemsStart=<>
                <li onClick={() => onCurrentPage(1)} className="pages__item"><span >{1}</span></li>
            </>;
        }


        return (<>
            <div className={"pages "+dopClass1}>
                <div className="pages-wrapper">
                    {elPrev}
                    <div className={"pages-list-wrapper "+dopClass2}>
                        <ul className="pages__list">
                            {itemsStart}
                            {items}
                            {itemsEnd}
                        </ul>
                    </div>
                    {elNext}
                </div>
            </div>
        </>);
    }

}